import { icons } from 'constants/assets';
import { FC } from 'react';

export const Loader: FC<{ width: number; height: number }> = ({
  width,
  height,
}) => (
  <div className="animate-spin [animation-duration:3s]">
    <img src={icons.loaderIcon} alt="loader" width={width} height={height} />
  </div>
);
